<template>
  <section>
    <NavBar />
    <section class="hero is-bold" :class="$style.customHero">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div id="textblock" class="column">
              <h2 class="title">Extractores disponibles</h2>
              <h5 class="subtitle">
                La plataforma de gestión de datos totalmente integrada de
                <strong>Connect</strong> hace que sea más fácil que nunca
                conectarse a sus datos.
              </h5>
            </div>
            <div class="column has-text-centered">
              <img
                :class="$style.heroImg"
                :src="heroImage"
                alt="hero"
                title="integrations hero"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container py-6">
        <div class="columns is-vcentered">
          <div class="column">
            <h3 class="title is-4">
              Connect te ayuda a controlar el flujo de tus datos comerciales más
              importantes
            </h3>
            <p class="subtitle mt-5">
              Trabajamos tanto generando extractores utilizando las API de tus
              aplicaciones como también creando RPAs para servicios que no
              cuenten con una. Si no tenemos lo que buscas, escríbenos.
            </p>
          </div>
        </div>
        <div class="columns is-vcentered py-6">
          <div class="column is-6">
            <p class="subtitle mt-5 is-5 has-text-weight-bold">Integra</p>
            <p class="subtitle mt-2">
              Utiliza cualquiera de nuestras integraciones ya desarrolladas para
              extraer la información de estos servicios, extrae solo los datos
              que te interesa analizar, revisa nuestro listado y detalle de
              integraciones
            </p>
            <p class="subtitle mt-5 is-5 has-text-weight-bold">Consolida</p>
            <p class="subtitle mt-2">
              Sube la información de tus servicios a tu base de datos y
              utilizala para analizar la información mediante tu software de
              business intelligence favorito. Actualmente contamos con
              integraciones para dejar tus datos en PostgreSQL o SQL Server
            </p>
          </div>
          <div class="column is-6 has-text-centered">
            <img style="max-width: 40%;" :src="sources" alt="logo" />
          </div>
        </div>
      </div>
      <div class="container py-6">
        <div class="columns is-vcentered">
          <div class="column">
            <h3 class="title is-4">Integraciones</h3>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="columns is-centered is-multiline is-inline-flex-mobile">
          <div
            v-for="extractor in extractors"
            :key="extractor.id"
            class="column is-6-mobile is-3-tablet"
          >
            <div class="tile is-ancestor">
              <div class="tile is-parent has-text-centered">
                <router-link
                  :to="{
                    name: 'integration',
                    params: { slug: extractor.slug },
                  }"
                >
                  <article
                    style="padding: 20px;"
                    class="tile is-child notification is-primary is-light"
                    :class="[$style.tilePadding, $style.tileStyles]"
                  >
                    <img
                      :class="$style.tileImage"
                      :src="extractor.logo"
                      alt="logo"
                    />
                    <p class="subtitle">
                      <span
                        class="tag is-rounded"
                        :class="{
                          'is-success': extractor.type === 'API',
                          'is-dark': extractor.type === 'RPA',
                        }"
                        >{{ extractor.type }}</span
                      >
                    </p>
                  </article>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </section>
</template>

<script>
import { NavBar, Footer } from "@/components";
import { heroIntegrations, sourcesLogos } from "@/assets/images";
import { extractors } from "@/utils";

export default {
  name: "Integrations",
  data: () => {
    return {
      heroImage: heroIntegrations,
      sources: sourcesLogos,
      extractors,
    };
  },
  components: {
    NavBar,
    Footer,
  },
};
</script>

<style lang="scss" module>
@import "../styles/home.scss";

.customHero {
  background: linear-gradient(
    0deg,
    rgba(27, 115, 232, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
}

.heroImg {
  max-width: 60%;
}

#textblock p {
  margin-top: 25px;
  font-size: 21px;
  text-align: center;
  animation: fadein 2s;
  -moz-animation: fadein 2s; /* Firefox */
  -webkit-animation: fadein 2s; /* Safari and Chrome */
  -o-animation: fadein 2s; /* Opera */
}
</style>
